import * as yup from 'yup';


const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const UserManagementValidationSchema = yup.object({
    Name: yup.string().nullable().required('Name is required'),
    Username: yup.string().nullable().required('Username is required'),
    Email: yup.string().nullable().email().required('Email is required'),
    TelephoneNumber: yup.string().nullable().required('Telephone Number is required').matches(phoneRegExp, 'Phone number is not valid'),
    UserType: yup.string().required('User Type is required').typeError('User Type is required'),
})